module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chap"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "26%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "8%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "66%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "partn"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('em', [_vm._v("Part One")])])]), _vm._v(" "), _c('td', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/line.jpg"
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "bottom"
    }
  }, [_c('p', {
    staticClass: "partc"
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("F THE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANTLE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITS")]), _vm._v(" . . .")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "imagep",
    attrs: {
      "id": "page_14"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "html/images/f0014-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c3c3944","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780292734746_10_pt01.vue
// module id = 87
// module chunks = 0